import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { Milestone } from '@shared/types.ts';
import { api } from './client.ts';

export function useMilestones(babyId: string | null | undefined) {
  return useQuery({
    queryKey: ['milestones', { babyId }],
    enabled: !!babyId,
    queryFn: () =>
      api<{ milestones: Milestone[] }>(`/api/milestones?baby=${encodeURIComponent(babyId!)}`),
    select: (d) => d.milestones,
  });
}

function useInvalidate() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['milestones'] });
}

export function useCreateMilestone() {
  const inv = useInvalidate();
  return useMutation({
    mutationFn: (vars: {
      kind: string;
      title: string;
      occurred_at?: number;
      notes?: string | null;
    }) =>
      api<{ milestone: Milestone }>('/api/milestones', {
        method: 'POST',
        json: vars,
      }),
    onSuccess: () => inv(),
  });
}

export function useUpdateMilestone() {
  const inv = useInvalidate();
  return useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: Record<string, unknown> }) =>
      api<{ milestone: Milestone }>(`/api/milestones/${id}`, {
        method: 'PATCH',
        json: patch,
      }),
    onSuccess: () => inv(),
  });
}

export function useDeleteMilestone() {
  const inv = useInvalidate();
  return useMutation({
    mutationFn: (id: string) => api(`/api/milestones/${id}`, { method: 'DELETE' }),
    onSuccess: () => inv(),
  });
}
